import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";

extendZodWithOpenApi(z);

/** Characters of a text version segment (manufacturer, product line, hardware variant), as a regex class body. */
export const TEXT_VERSION_SEGMENT_CHARACTERS = "A-Za-z";

const textVersionSegmentPattern = `^[${TEXT_VERSION_SEGMENT_CHARACTERS}]+$`;

const textVersionSegmentMessage = "Must be a device version text segment: one or more ASCII letters, as in BLOCK";

/**
 * Zod schema for a text segment of a device version: a manufacturer, product line or hardware variant. Checked in any
 * case, then uppercased, so a lowercase segment from a producer still resolves.
 */
export const TextVersionSegmentString = z
    .string()
    .regex(new RegExp(textVersionSegmentPattern), { message: textVersionSegmentMessage })
    .toUpperCase()
    .openapi({
        type: "string",
        pattern: textVersionSegmentPattern,
        description: "Device version text segment (ASCII letters)",
        example: "BLOCK",
    });

/**
 * Zod schema for a text version segment in its stored, uppercase form. Unlike {@link TextVersionSegmentString} it does
 * not uppercase, so a lowercase segment is rejected.
 */
export const StoredTextVersionSegmentString = z
    .string()
    .regex(new RegExp(textVersionSegmentPattern), { message: textVersionSegmentMessage })
    .regex(/^[^a-z]*$/, { message: "Must be uppercase" })
    .openapi({
        type: "string",
        pattern: textVersionSegmentPattern,
        description: "Device version text segment (ASCII letters), uppercase",
        example: "BLOCK",
    });

/** Zod schema for a numeric segment of a device version: generation, hardware version or firmware version. */
export const NumericVersionSegment = z
    .number()
    .int()
    .nonnegative()
    .openapi({ type: "integer", minimum: 0, description: "Device version numeric segment", example: 4 });
